export default {
  button: {
    button_view_product: 'View product',
    button_enter_erp: 'Enter ERP',
    confirm: 'confirm',
    Reauthorize: 'Reauthorize',
    Upload: 'Upload',
    'View Products': 'View Products',
    Save: 'Save',
    Search: 'Search',
    Cancel: 'Cancel',
    'Add Template': 'Add Template',
    Submit: 'Submit',
    'Add Submit': 'Add Submit',
    'Upload more': 'Upload More',
    'Upload History': 'Upload History',
    Edit: 'Edit',
    Start: 'Start',
    Confirm: 'Confirm',
    Authorize: 'Authorize',
    'Export Review': 'Export Review',
    'List Now': 'List Now',
    Delete: 'Delete',
    'Add List': 'Add List',
    'Listing Templats': 'Listing Templats',
    Connect: 'Connect',
    Select: 'Select',
    'Simultaneously Matching Other Platform Products': 'Simultaneously Matching Other Platform Products',
    Connection: 'Connection',
    'Get Code': 'Get Code'
  },
  page: {
    Total: 'Total',
    'Search Results': 'Search Results'
  },
  platformTitleFlag: {
    Platform: 'Platform',
    'Add More': 'Add More'
  },
  uploadTask: {
    uploadtask_accountname: 'AccountName',
    'Task Center': 'Task Center',
    Processing: 'Processing',
    Completed: 'Completed',
    'The task list is empty, you can upload products or sync orders': 'The task list is empty, you can upload products or sync orders',
    'Upload Product': 'Upload Product',
    'Sync orders': 'Sync Orders',
    Success: 'Success',
    Failed: 'Failed',
    Ignored: 'Ignored',
    'Task type': 'Task type',
    Language: 'Language',
    Brand: 'Brand',
    'Create time': 'Create time',
    Warehouse: 'Warehouse',
    'Price markup': 'Price markup',
    'Select products by': 'Select products by',
    Category: 'Category',
    'including words': 'including words',
    'Start time': 'Start time',
    'End time': 'End time',
    'End Time': 'End Time',
    Status: 'Status',
    OrderNumber: 'OrderNumber',
    'Re-operation type': 'Re-operation type',
    Resume: 'Resume',
    'Task resumes where it left off': 'Task resumes where it left off',
    Restart: 'Restart',
    'The system will automatically filter the product that has been successfully published. Please do not change the SKU numbers to prevent the system from mistakenly believe that it has not been published':
      'The system will automatically filter the product that has been successfully published. Please do not change the SKU numbers to prevent the system from mistakenly believe that it has not been published',
    'Task re-execution': 'Task re-execution',
    'Confirm deletion of this task': 'Confirm deletion of this task',
    All: 'All',
    RefNo: 'RefNo',
    'Create time / Update time': 'Create time / Update time',
    Account: 'Account',
    Type: 'Type',
    Total: 'Total',
    Options: 'Options',
    Order: 'Order',
    Product: 'Product'
  },
  search: {
    search_keyword: 'Keyword',
    SPU: 'SPU',
    SKU: 'SKU',
    Stores: 'Stores',
    Brand: 'Brand',
    ItemNo: 'ItemNo',
    Warehouse: 'Warehouse',
    Category: 'Category',
    'Shopify Collection': 'Shopify Collection',
    'Item #': 'Item #',
    Title: 'Title',
    Status: 'Status',
    'Product Title': 'Product Title',
    'SUNSKY SKU': 'SUNSKY SKU',
    'Store SKU': 'Store SKU'
  },
  menus: {
    Dashboard: 'Dashboard',
    ordersManagement: 'orders management'
  },
  guide: {
    'Let’s get you started': "Let's get you started",
    'Complete the following tasks to quickly start your new business': 'Complete the following tasks to quickly start your new business',
    STEP: 'STEP',
    complete: 'complete',
    'Connect to your store': 'Connect to your store',
    'Supporting multiple platforms': 'Supporting multiple platforms',
    'Upload product': 'Upload product',
    'Support for bulk publication': 'Support for bulk publication',
    'Place an order at SUNSKY': 'Place an order at SUNSKY',
    'Automatically generate orders and place orders quickly': 'Automatically generate orders and place orders quickly',
    'SUNSKY ships and synchronizes the tracking number': 'SUNSKY ships and synchronizes the tracking number',
    'Automatically synchronize shipment information to your store': 'Automatically synchronize shipment information to your store',
    Upload: 'Upload',
    'Place Order': 'Place Order'
  },
  notFound: {
    'Sorry, the page you visited does not exist': 'Sorry, the page you visited does not exist',
    'Return to homepage': 'Return to homepage'
  },
  layOut: {
    'Reselling Service': 'Reselling Service',
    'Quick Start': 'Quick Start',
    'Task Center': 'Task Center',
    Progress: 'Progress',
    'Go to SUNSKY': 'Go to SUNSKY',
    'Upload Template': 'Upload Template',
    Dashboard: 'Dashboard',
    Orders: 'Orders',
    Stores: 'Stores',
    Products: 'Products',
    'Upload Products': 'Upload Products',
    Connection: 'Connection',
    Platform: 'Platform',
    'Platform Settings': 'Platform Settings',
    layout_platform_monitor: 'Monitor',
    layout_store_monitor: 'Store Monitor',
    layout_user_monitor: 'User Monitor',
    layout_product_monitor: 'Product Monitor',
    layout_order_monitor: 'Order Monitor',
    layout_product_error: 'Product Error'
  },
  Dashboard: {
    dashboard_nodata_tips: 'The list is empty. Please upload products or sync orders',
    dashboard_day: 'Day',
    dashboard_nodata: 'No Data',
    dashboard_week: 'Week',
    dashboard_month: 'Month',
    'Key Metrics': 'Key Metrics',
    'Added to lmport List successfully': 'Added to lmport List successfully',
    'View Import List': 'View Import List',
    'Sales Overview': 'Sales Overview',
    'Top 10 Selling Products': 'Top 10 Selling Products',
    'Top 10 Selling Categories': 'Top 10 Selling Categories',
    'Products Recommendation': 'Products Recommendation',
    Products: 'Products',
    Units: 'Units',
    Amount: 'Amount',
    'Total Orders': 'Total orders',
    'Total Sales': 'Total sales',
    StoreProducts: 'Store products',
    'Newly Uploaded Products': 'Newly uploaded products',
    Wholesale: 'Wholesale',
    'Publish to Store': 'Publish to Store',
    'Add Import List': 'Add Import List',
    'Remove form to import list': 'Remove form to import list'
  },
  homePage: {
    homepage_help_you: 'Help You',
    homepage_buildweb: 'Build Website',
    homepage_is_the_initial: 'Is the initial workload of building an independent website heavy',
    homepage_submit_your_require: 'Submit your requirements and we will help you bulk upload products, customize websites, link Google advertising accounts, traffic monitoring, Trustpilot accounts, payment accounts, etc.',
    homepage_submit_require: 'Submit Requirements',
    homepage_pay_only: 'Pay Only if Satisfied',
    homepage_hlep_your_build: 'Help You Build A Website Quickly',
    homepage_we_will_help: 'We will help you quickly build your website and you will only pay after you are satisfied.',
    homepage_sub_require: 'Submit requirements',
    homepage_submit_your_business: 'Submit your business direction and reference examples of website design',
    homepage_confirm_and: 'Confirm and pay deposit',
    homepage_pay_the_deposit: 'Pay the deposit after confirming the requirements',
    homepage_quick_customize: 'Quickly customize website',
    homepage_our_team_will: 'Our team will quickly build your website based on your needs',
    homepage_pay_only_when: 'Pay only when you are satisfied, you can request improvements or refund',
    homepage_what_can_we: 'What Can We Help You Build Website',
    homepage_quick_upload: 'Quickly upload products',
    homepage_use_our: 'Use our system to quickly upload to your website and set up upload templates. Once we have new products, they will be automatically uploaded to your website.',
    homepage_design_your: 'Designing your initial website',
    homepage_design_your_initial: 'Design your initial website based on your product and needs',
    homepage_config_website: 'Configure your website',
    homepage_config_website_content: 'Configure your website basic information, logistics methods, register Google advertising account, traffic monitoring, Trustpilot account, link payment account, etc.',
    homepage_website_operation: 'Website operation agency',
    homepage_we_supprot_website_services: 'In addition, we support website operation services, allowing you to focus on local customer service',
    homepage_form_email: 'Your email',
    homepage_form_language: 'Website language',
    homepage_form_category: 'Website business category',
    homepage_form_currency: 'Website currency',
    homepage_form_domain: 'Website domain',
    homepage_form_app: 'WhatsApp',
    homepage_form_other: 'Other information',
    homepage_webbuild: 'Website Building',
    homepage_please_other: 'Please enter your other requirements',
    homepage_in_additoon: 'In addition, we also provide agency operation services',
    homepage_we_help_you: 'We help you quickly upload products in batches, configure basic website information, and design the website according to your needs.',
    homepage_Requirements: 'Requirements',
    homepage_submit_the_form: 'Submit the form on the right and we will confirm your needs as soon as possible',
    homepage_buildweb: 'Build Website',
    'SUNSKY ERP': 'SUNSKY ERP',
    Products: 'Products',
    Login: 'Login',
    Register: 'Register',
    'Sign in now': 'Sign in now',
    Email: 'Email',
    'Reset Password': 'Reset Password',
    'Import products into your store in bulk, automate your fulfillment process and ship your packages quickly with SUNSKY': 'Import products into your store in bulk, automate your fulfillment process and ship your packages quickly with SUNSKY',
    'Wholesale and Dropshipping on multi-Platform': 'Wholesale and Dropshipping on Multi-Platform',
    'Start for free': 'Start for Free',
    'How We Help Your Business Grow': 'How We Help Your Business Grow',
    'Just 4 simple steps to greatly improve your work efficiency!': 'Just 4 simple steps to greatly improve your work efficiency!',
    '1. Integrate Your Store': '1. Integrate Your Store',
    'Connect your online store to import products to sell automatically': 'Connect your online store to import products to sell automatically',
    '2. Receive Orders': '2. Receive Orders',
    'Your customer orders flow seamlessly to our fulfillment system': 'Your customer orders flow seamlessly to our fulfillment system',
    '3. Manage Products': '3. Manage Products',
    'Lock Stock, Automatically update prices, list to sell and set stock out': 'Lock stock, automatically update prices, list to sell and set stock out',
    '4. Ship Orders': '4. Ship Orders',
    'We pick, pack, and ship orders to your customers on your behalf': 'We pick, pack, and ship orders to your customers on your behalf',
    'What is SUNSKY ERP': 'What Is SUNSKY ERP',
    'SUNSKY ERP is a SaaS system under SUNSKY that provides one-stop service for global e-commerce sellers': 'SUNSKY ERP is a SaaS system under SUNSKY that provides one-stop service for global e-commerce sellers',
    'The head office was established in 2005, focusing on global sales and wholesale e-commerce platforms, with product SKU reaching millions': 'The head office was established in 2005, focusing on global sales and wholesale e-commerce platforms, with product SKU reaching millions',
    'integrates multiple platforms for users, and provides services such as product batch publishing, Dropshipping, order management, and report analysis': 'Integrates multiple platforms for users, and provides services such as product batch publishing, Dropshipping, order management, and report analysis',
    'Professional Team': 'Professional Team',
    'SUNSKY ERP relies on rich experience in e-commerce operations, an excellent IT technical team, and a strong supply chain system. While providing millions of products for delivery, it continues to add and optimize ERP functions':
      'SUNSKY ERP relies on rich experience in e-commerce operations, an excellent IT technical team, and a strong supply chain system. While providing millions of products for delivery, it continues to add and optimize ERP functions',
    'Product Sourcing': 'Product Sourcing',
    'We not only provide millions of SKUs, but you can also request your products. Our professional product team will provide you with products with price advantages at the fastest speed': 'We not only provide millions of SKUs, but you can also request your products. Our professional product team will provide you with products with price advantages at the fastest speed',
    'Order Fulfillment': 'Order Fulfillment',
    'Automatically synchronize store orders, automatically place orders, and automatically synchronize tracking numbers to stores. All products are strictly tested before shipment': 'Automatically synchronize store orders, automatically place orders, and automatically synchronize tracking numbers to stores. All products are strictly tested before shipment',
    'Store Management': 'Store Management',
    'SUNSKY ERP integrates multiple platforms, allowing customers to manage multiple platforms in a one-stop manner, improving customer operational efficiency': 'SUNSKY ERP integrates multiple platforms, allowing customers to manage multiple platforms in a one-stop manner, improving customer operational efficiency',
    'Locked Stock': 'Locked Stock',
    'You can place inventory orders for future products, and SUNSKY provides you with free warehousing services. This not only avoids out of stock, but also improves delivery timeliness': 'You can place inventory orders for future products, and SUNSKY provides you with free warehousing services. This not only avoids out of stock, but also improves delivery timeliness',
    'Customer Service': 'Customer Service',
    'SUNSKY ERP provides 24 hours a day service, you can get help in our help center, or consult our professional online team': 'SUNSKY ERP provides 24 hours a day service, you can get help in our help center, or consult our professional online team',
    'Why choose SUNSKY': 'Why Choose SUNSKY',
    'Sunsky has been operating in China for more than 18 years and has accumulated rich supply chain resources. Under the': 'SUNSKY has been operating in China for more than 18 years and has accumulated rich supply chain resources. Under the',
    'premise of ensuring product quality and price advantages, its products have reached the million': 'premise of ensuring product quality and price advantages, its products have reached the million',
    'Wholesale price of millions of products': 'Wholesale Price of Millions of Products',
    'SUNSKY directly cooperate with factories, offer best price, at the same time we guarantee high quality products and fast shipping service': 'SUNSKY directly cooperate with factories, offer best price, at the same time we guarantee high quality products and fast shipping service',
    'Through the comprehensive quality control, all products undergo supplier review, arrival inspection & scan, and are tested to strict quality control standards': 'Through the comprehensive quality control, all products undergo supplier review, arrival inspection & scan, and are tested to strict quality control standards',
    '19 categories, including over 800 brands': '19 categories, including over 800 brands',
    'Inventory products are shipped on the same day': 'Inventory products are shipped on the same day',
    'Free and powerful ERP': 'Free and Powerful ERP',
    'There is no trial period, SUNSKY ERP is free to use': 'There is no trial period, SUNSKY ERP is free to use',
    'We only charge when you place an order on our platform, and only charge product fees and shipping fees': 'We only charge when you place an order on our platform, and only charge product fees and shipping fees',
    'Unlimited number of connected stores': 'Unlimited number of connected stores',
    'integrate platforms including shopify, magento, woocomerce, etc., and continue to add new ones': 'Integrate platforms including shopify, magento, woocomerce, etc., and continue to add new ones',
    'Intelligent automated processing': 'Intelligent Automated Processing',
    'Upload products in bulk according to your publishing requirements': 'Upload products in bulk according to your publishing requirements',
    'Automatically synchronize store orders to SUNSKY ERP, and support setting automatic order placement': 'Automatically synchronize store orders to SUNSKY ERP, and support setting automatic order placement',
    'After the order is shipped, the tracking number will be automatically synchronized to your store, saving you a lot of time': 'After the order is shipped, the tracking number will be automatically synchronized to your store, saving you a lot of time',
    'Global Warehouse, Global Shipment': 'Global Warehouse, Global Shipment',
    'Sunsky has cooperated with various professional international shipping companies, providing door to door delivery service to more than 200 countries and regions,ensure your customer gets the best possible experience':
      'SUNSKY has cooperated with various professional international shipping companies, providing door to door delivery service to more than 200 countries and regions,ensure your customer gets the best possible experience',
    'Sunsky warehouses are located in China, Hongkong, USA, United Kingdom and United Arab Emirates, which helps reduce the delivery time to only 1 - 2 days and provides more efficient and convenient after-sales services for global users. All orders that shipped from local warehouse have duty free with fast shipping around 3 days':
      'SUNSKY warehouses are located in China, Hongkong, USA, United Kingdom and United Arab Emirates, which helps reduce the delivery time to only 1 - 2 days and provides more efficient and convenient after-sales services for global users. All orders that shipped from local warehouse have duty free with fast shipping around 3 days',
    'Support locking inventory, place an order in advance to lock inventory, wait until the order is issued, and then ship, improve delivery time and avoid out of stock': 'Support locking inventory, place an order in advance to lock inventory, wait until the order is issued, and then ship, improve delivery time and avoid out of stock',
    'Easily distribute products to multiple platforms': 'Easily Distribute Products to Multiple Platforms',
    'SUNSKY integrates multiple platforms and continues to integrate more, so stay tuned': 'SUNSKY integrates multiple platforms and continues to integrate more, so stay tuned',
    'Add Store': 'Add Store',
    'Start your dropshipping business today': 'Start Your Dropshipping Business Today',
    'SUNSKY directly cooperate with factories': 'SUNSKY directly cooperate with factories',
    'offer best price': 'offer best price',
    'Professional quality inspection process to': 'Professional quality inspection process to',
    'ensure product quality': 'ensure product quality',
    'A variety of logistics options are available to': 'A variety of logistics options are available to ',
    'ensure the timeliness of transportation': 'ensure the timeliness of transportation',
    'Contact Information': 'Contact Information',
    'About Us': 'About Us',
    'Contact Us': 'Contact Us',
    Email: 'Email',
    Address: 'Address',
    '8/F,No.614 Building,Bagua 1st Road': '8/F,No.614 Building,Bagua 1st Road',
    'Futian District,Shenzhen,China': 'Futian District,Shenzhen,China',
    'Service & Support': 'Service & Support',
    'Wholesale Program': 'Wholesale Program',
    'SUNSKY Points': 'SUNSKY Points',
    'Open API Services': 'Open API Services',
    'Privacy Notice': 'Privacy Notice',
    'Terms of Use': 'Terms of Use',
    'Affiliate Program': 'Affiliate Program',
    招聘启事: '招聘启事',
    电商孵化官网: '电商孵化官网',
    'Payment & Shipping': 'Payment & Shipping',
    'Payment Method': 'Payment Method',
    'Drop Shipping': 'Drop Shipping',
    "Buyer's Show": "Buyer's Show",
    'How to Unsubscribe': 'How to Unsubscribe',
    'Shipping & Handling': 'Shipping & Handling',
    'Duties & Taxes': 'Duties & Taxes',
    'Refund & Cancellation': 'Refund & Cancellation',
    寻找优质供应商: '寻找优质供应商',
    'Help & Resources': 'Help & Resources',
    'View Site Map': 'View Site Map',
    'Get RSS Feed': 'Get RSS Feed',
    'Download Android Client': 'Download Android Client',
    'Download iPhone Client': 'Download iPhone Client',
    'Sign in': 'Sign in',
    'Name/Email': 'Name/Email',
    'Email Address': 'Email Address',
    Password: 'Password',
    'Remember me and login automatically': 'Remember me and login automatically',
    'Re-type Password': 'Re-type Password',
    'Cellphone Number': 'Cellphone Number',
    'Verification Code': 'Verification Code',
    'SMS Validate Code': 'SMS Validate Code',
    'Get SMS Code': 'Get SMS Code',
    'Terms and Conditions': 'Terms and Conditions',
    'I accept the SUNSKY': 'I accept the SUNSKY',
    'Register and get US$5 off code': 'Register and get US$5 off code',
    'Forgot password?Click here': 'Forgot password?Click here',
    'Register with your Phone Number': 'Register with your Phone Number',
    'Return to register with your Email': 'Return to register with your Email',
    'Sign in with': 'Sign in with',
    Shopify: 'Shopify',
    Woocommerce: 'Woocommerce',
    TikTok: 'TikTok',
    Magento: 'Magento',
    Bigcommerce: 'Bigcommerce',
    Wix: 'Wix',
    Shift4shop: 'Shift4shop',
    Volusion: 'Volusion',
    Joom: 'Joom',
    'back to Top': 'back to Top'
  },
  uploadProduct: {
    uploadproduct_5star: 'Same day shipping',
    uploadproduct_4star: '2-3 days',
    uploadproduct_3star: '3-5 days',
    uploadproduct_2star: '5-15 days',
    uploadproduct_1star: '15 days+',
    uploadproduct_baseon: 'based on',
    uploadproduct_my: 'my member price',
    uploadproduct_1unit: '1 unit price',
    uploadproduct_all_brand: '-- All Branded Items --',
    uploadproduct_due_to: 'Due to the platform limited number of variants, the system has split the product for publish.',
    uploadproduct_no_product: 'No Product can publish',
    uploadproduct_upload_message_success: 'Upload task has been successfully created, you can view the progress in the task center',
    uploadproduct_select_product: 'Select a Product',
    uploadproduct_shopline_collection: 'Shopline Collection',
    uploadproduct_go_to_create: 'Go to create a profile',
    uploadproduct_no_store_three: 'You have no store profiles yet please click the button below to continue',
    uploadproduct_no_store_one: "You don't have a store to upload products yet",
    uploadproduct_no_store_two: 'Please authorize your store first to activate one-click product listing and automatic order fulfillment',
    Weight: 'Weight',
    SPU: 'SPU',
    round: 'round',
    '2 decimal places': '2 decimal places',
    '1 decimal places': '1 decimal places',
    integer: 'integer',
    tens: 'tens',
    hundreds: 'hundreds',
    thousands: 'thousands',
    'round up': 'round up',
    'round down': 'round down',
    'Upload to store': 'Upload to store',
    uploadproduct_update_to_store: 'Update to store',
    Stars: 'Stars',
    uploadproduct_leadtime: 'Lead time',
    'Upload Products': 'Upload Products',
    Store: 'Store',
    'Item #': 'Item #',
    'Separated by comma/whitespace': 'Separated by comma/whitespace',
    'Separated by comma': 'Separated by comma',
    "Save it and display it's store next time": "Save it and display it's store next time",
    'Select products by': 'Select products by',
    Conditions: 'Conditions',
    // Item: 'Item',
    Languange: 'Languange',
    Warehouse: 'Warehouse',
    'Only Free Shipping': 'Only Free Shipping',
    'Only those items with a lead time of less than 5 days': 'Only those items with a lead time of less than 5 days',
    Category: 'Category',
    Brand: 'Brand',
    'Including words': 'Including words',
    'Separated by comma/whitespace': 'Separated by comma/whitespace',
    'Must match all': 'Must match all',
    'Excluding words': 'Excluding words',
    'Price range': 'Price range',
    'Price markup': 'Price markup',
    'Add shipping cost for unit and display free shipping price': 'Add shipping cost for unit and display free shipping price',
    and: 'and',
    Vendor: 'Vendor',
    None: 'None',
    'Use brand name as vendor': 'Use brand name as vendor',
    'Use SUNSKY as vendor': 'Use SUNSKY as vendor',
    'Shopify collection': 'Shopify collection',
    'Add specifications to description': 'Add specifications to description',
    'Use top category name as product type': 'Use top category name as product type',
    'Add top category names to tags': 'Add top category names to tags',
    'Add 2nd category names to tags': 'Add 2nd category names to tags',
    'Add 3nd category names to tags': 'Add 3nd category names to tags',
    'Add brand name to tags': 'Add brand name to tags',
    'Prefix of brand name': 'Prefix of brand name',
    'Prefix of top category': 'Prefix of top category',
    'Prefix of 2nd category': 'Prefix of 2nd category',
    'Prefix of 3nd category': 'Prefix of 3nd category',
    'Charge tax on product': 'Charge tax on product',
    'Automatically update once a day': 'Automatically update once a day',
    'Basic info': 'Basic info',
    Title: 'Title',
    Description: 'Description',
    Price: 'Price',
    'Listing status': 'Listing status',
    Images: 'Images',
    'Start Uploading': 'Start Uploading',
    to: 'to',
    'Upload product quantity': 'Upload product quantity',
    'There are': 'There are',
    'products that meet the upload requirements': 'products that meet the upload requirements',
    'Attribute Set': 'Attribute Set',
    'Price rounding': 'Price rounding',
    Others: 'Others',
    'Set Template': 'Set Template',
    'Gross Weight': 'Gross Weight',
    'Volume Weight': 'Volume Weight',
    Larger: 'Larger',
    kg: 'kg',
    cm: 'cm',
    'Length (cm) * Width (cm) * Height (cm)': 'Length (cm) * Width (cm) * Height (cm)',
    'for first weight': 'for first weight',
    'for additional weight': 'for additional weight',
    'Enable COD': 'Enable COD',
    'TikTok can set COD for certain categories of products. When the products you upload involve these categories, you can choose whether to enable them or not': 'TikTok can set COD for certain categories of products. When the products you upload involve these categories, you can choose whether to enable them or not',
    uploadproduct_iframe_content_two: 'You can enter ERP to view task progress',
    uploadproduct_iframe_content_one: 'The current SKU is being listed, please wait for the task to be completed',
    uploadproduct_iframe_content_title: 'Information'
  },
  storeManagement: {
    storeManagement_seller_type: 'Seller Type',
    storemanagement_tip_one: "You could upload product data to your store on the 'upload products' page.",
    storemanagement_tip_two: 'DO NOT CHANGE THE SKU NUMBERS IN YOUR STORE',
    storemanagement_tip_three: `Once an order is placed at your store, it'll be downloaded into the 'Orders' page and you could place a corresponding order with SUNSKY by clicking the "Create SUNSKY Order" button in the lines.`,
    storemanagement_tip_four: 'SUNSKY will update the tracking number automatically to your store when the order is shipped.',
    storemanagement_no_data_tips: 'You do not have a valid account, please authorize first',
    storemanagement_success_one: 'Successful',
    storemanagement_success_two: 'Next, you can upload product, fulfill order, connect product',
    storemanagement_success_three: 'List SUNSKY products to your store',
    storemanagement_success_four: 'List Now',
    storemanagement_success_five: 'Fulfill your stores orders now',
    storemanagement_success_six: 'Fulfill Now',
    storemanagement_success_seven: 'Connect your products to SUNSKY now',
    storemanagement_success_eight: 'Connect Now',
    storemanagement_modal_one: 'You should set up SUNSKY shipping/return warehouse in your TikTok management platform. If multiple shipping warehouses are set up, the SUNSKY warehouse is listed first.',
    storemanagement_modal_two: 'View warehouse address',
    storemanagement_modal_three: 'reauthorization successful.',
    storemanagement_storehash: 'Storehash',
    storemanagement_off: 'Off/On',
    Handle: 'Handle',
    'Add Your Store': 'Add Your Store',
    'Authorize your store to activate one-click product listing and automatic order fulfillment': 'Authorize your store to activate one-click product listing and automatic order fulfillment',
    'How to connect': 'How to connect',
    'Add Store': 'Add Store',
    'API integration? Learn about SUNSKY API services': 'API integration? Learn about SUNSKY API services',
    New: 'New',
    'Site url': 'Site url',
    'Example:If your website is https://www.sunsky-online.com, please fill in www.sunsky-online.com, excluding (https://). Please fill in correctly.': 'Example:If your website is https://www.sunsky-online.com, please fill in www.sunsky-online.com, excluding (https://). Please fill in correctly.',
    'Store Profile': 'Store Profile',
    Name: 'Name',
    'A name friendly and easy to distinguish': 'A name friendly and easy to distinguish',
    Hostname: 'Hostname',
    'Admin API Access Token': 'Admin API access token',
    'Store Currency': 'Store currency',
    'Use the shipping data from SUNSKY API': 'Use the shipping cost from SUNSKY API',
    'Listing Templates': 'Listing Templates',
    'When you upload a product, it will be automatically filled in based on the content of the template': 'When you upload a product, it will be automatically filled in based on the content of the template',
    'Automatic Order Placement': 'Automatic Order Placement',
    'Listing Template': 'Listing Template',
    'include shipping': 'include shipping',
    'Add Template': 'Add Template',
    'Edit Template': 'Edit Template',
    'Template Name': 'Template Name',
    Plaform: 'Plaform',
    'Price Settings': 'Price Settings',
    'SUNSKY Price': 'SUNSKY Price',
    'Add shipping cost for unit and display free shipping price': 'Add shipping cost for unit and display free shipping price',
    'Same Price as Set Last Time': 'Same Price as Set Last Time',
    to: 'to',
    'then subtract': 'then subtract',
    PriceSettings: 'PriceSettings',
    'Price rounding': 'Price rounding',
    'Update Time': 'Update Time',
    Operater: 'Operater',
    'Automatically create orders in SUNSKY when there are new orders.If the product is out of stock, you need to manually create an order': 'Automatically create orders in SUNSKY when there are new orders.If the product is out of stock, you need to manually create an order',
    'Consumer Key': 'Consumer key',
    'Consumer Secret': 'Consumer secret',
    'Magento Version': 'Magento Version',
    'Access Token': 'Access Token',
    'Store Hash': 'Store Hash',
    'Client id': 'Client id',
    Code: 'Code',
    'Example: If your website is https://www.sunsky-online.com, please fill in https://www.sunsky-online.com. Please fill in correctly.': 'Example: If your website is https://www.sunsky-online.com, please fill in https://www.sunsky-online.com. Please fill in correctly.',
    HINT: 'HINT',
    'After creating the store profile, you could upload product data to your Shopify store by clicking the "Upload more" button in the "Product Listings" page. DO NOT CHANGE THE SKU NUMBERS IN YOUR SHOPIFY STORE!':
      'After creating the store profile, you could upload product data to your Shopify store by clicking the "Upload more" button in the "Product Listings" page. DO NOT CHANGE THE SKU NUMBERS IN YOUR SHOPIFY STORE!',
    'New Store Profile': 'New Store Profile',
    'How to connect Shopify?': 'How to connect Shopify?',
    'SUNSKY Shipping Data': 'SUNSKY Shipping Data',
    'Shipping Cost Markup': 'Shipping Cost Markup',
    Status: 'Status',
    Options: 'Options'
  },
  formTips: {
    formtips_store_currency: 'Please select Store currency',
    formtips_markup: 'Please input Price markup',
    formtips_sale_empty: 'TikTok Sale Country cannot be empty',
    formtips_name_tip: '',
    formtips_hostname_tip: '',
    formtips_adminurl_tip: '',
    formtips_handle_tip: '',
    formtips_api_tip: '',
    formtips_siturl_tip: '',
    formtips_input_platformname: 'please input platformName',
    formtips_select_shopline: 'please select Shopline Collection',
    formtips_select_tiktok: 'please select Tiktok Category',
    'please input Order number': 'please input Order number',
    'Please select Store': 'Please select Store',
    'Please select language': 'Please select language',
    'Please select Order date': 'Please select Order date',
    'Please select SubAccount': 'Please select SubAccount',
    'Please select Order status': 'Please select Order status',
    'Please input Price markup': 'Please input Price markup',
    'Please input Selling Price': 'Please input Selling Price',
    'please select category': 'please select category',
    'please select language': 'please select language',
    'Please enter Spu, separated by comma/whitespace': 'Please enter Spu, separated by comma/whitespace',
    'please select Attribute Set': 'please select Attribute Set'
  },
  platformSetting: {
    'Add Platform': 'Add Platform',
    'Edit Platform': 'Edit Platform',
    No: 'No',
    Yes: 'Yes',
    'Sub-Account': 'Sub-Account',
    'Platform Name': 'Platform Name',
    Platform: 'Platform',
    'Title max length': 'Title max length',
    'Variants maximum number': 'Variants maximum number',
    Status: 'Status',
    Sort: 'Sort',
    Options: 'Options'
  },
  orders: {
    orders_syn_order: 'Sync order task is created successfully, you can view the progress in the task center',
    orders_success: 'SUNSKY order created successfully',
    orders_create_order_tips: 'Some TikTok sites have encrypted shipping addresses. If the * symbol is displayed in the address, please verify the complete shipping address with the buyer',
    orders_create_order_wixtips: 'Since the wix platform can only obtain the abbreviation of State, in order not to affect delivery, please fill in the complete State',
    orders_Sync: 'Sync',
    'Click to view connection products': 'Click to view connection products',
    'This product is already connected to the SUNSKY product and will be ordered according to the connected product': 'This product is already connected to the SUNSKY product and will be ordered according to the connected product',
    'Product List': 'Product List',
    Product: 'Product',
    Price: 'Price',
    Unit: 'Unit',
    'Bundled products': 'Bundled products',
    'Specify Sync Order': 'Specify Sync Order',
    'Order status': 'Order status',
    'Order date': 'Order date',
    SubAccount: 'SubAccount',
    'Magento does not support sync orders by time, please choose to specify sync order': 'Magento does not support sync orders by time, please choose to specify sync order',
    'Batch Sync Orders': 'Batch Sync Orders',
    'Are you sure delete': 'Are you sure delete',
    'Shipping Methods': 'Shipping Methods',
    'Shipping Address': 'Shipping Address',
    'The order ID is': 'The order ID is',
    'For example': 'For example',
    'Open the order details page, and the number after the URL is the order ID': 'Open the order details page, and the number after the URL is the order ID',
    'Not support': 'Not support',
    'Order ID': 'Order ID',
    'Order number': 'Order number',
    HINT: 'HINT',
    'At the same time, the maximum number of tasks is allowed to allow only': 'At the same time, the maximum number of tasks is allowed to allow only 3',
    'Batch sync orders, limit sync once per hour': 'Batch sync orders, limit sync once per hour',
    'The list is empty, sync orders immediately': 'The list is empty, sync orders immediately',
    'Sync orders': 'Sync Orders',
    'Out of Stock': 'Out of Stock',
    Disconnected: 'Disconnected',
    'Go to sunsky-online.com': 'Go to sunsky-online.com',
    'Please search for SUNSKY ItemNo': 'Please search for SUNSKY ItemNo',
    'Place SUNSKY order in currency': 'Place SUNSKY order in currency',
    All: 'All',
    'Platform Status': 'Platform Status',
    'Wait Create': 'Wait Create',
    Paid: 'Paid',
    Exception: 'Exception',
    Pending: 'Pending',
    Shipping: 'Shipping',
    Delivered: 'Delivered',
    Cancelled: 'Cancelled',
    Deleted: 'Deleted',
    'Order#': 'Order#',
    'Order Time': 'Order Time',
    'Update Time': 'Update Time',
    Store: 'Store',
    Customer: 'Customer',
    Total: 'Total',
    Items: 'Items',
    'Shipping Method': 'Shipping Method',
    'SUNSKY Order': 'SUNSKY Order',
    'Create SUNSKY order': 'Create SUNSKY Order',
    Check: 'Check',
    Item: 'Item',
    'Item #': 'Item #',
    Units: 'Units',
    UnPaid: 'UnPaid',
    Stores: 'Stores',
    Connect: 'Connect',
    'The order product does not match the SUNSKY product. Please click Connect first': 'The order product does not match the SUNSKY product. Please click Connect first'
  },
  products: {
    products_All_products: 'All products under the current filter conditions',
    products_price_ex: 'Price Ex. VAT',
    products_bulk: 'Bulk revise selling price',
    products_shift4_price_tip: 'Due to the limitations of Shift4shop price settings, when a product has two Options, the price of an Options attribute can only be the same. please note',
    products_keep_price: 'Keep Price',
    'Immediate update tasks': 'Immediate update tasks',
    'Task created successfully': 'Task created successfully',
    'Weight(Kgs)': 'Weight(Kgs)',
    'Delete selected': 'Delete selected',
    'Delist selected': 'Delist selected',
    'Enlist selected': 'Enlist selected',
    'Update selected': 'Update selected',
    'Delete all': 'Delete all',
    'Delist all': 'Delist all',
    'Enlist all': 'Enlist all',
    'Update all': 'Update all',
    'Confirm delete selected': 'Confirm delete',
    'Confirm delist selected': 'Confirm delist',
    'Confirm enlist selected': 'Confirm enlist',
    'Confirm update selected': 'Confirm update',
    'SUNSKY Price': 'SUNSKY Price',
    'Auto Update': 'Auto Update',
    'include shipping': 'include shipping',
    'SUNSKY Link': 'SUNSKY Link',
    Published: 'Published',
    Delisted: 'Delisted',
    'Out of stock': 'Out of stock',
    'Please note that this price is price ex. vat, not localized final price': 'Please note that this price is price ex. vat, not localized final price',
    'Store Link': 'Store Link',
    'Selling Price': 'Selling Price',
    Account: 'Account',
    Tags: 'Tags',
    Variant: 'Variant',
    None: 'None',
    'Use top category': 'Use top category',
    'Use 2nd category name': 'Use 2nd category name',
    'Use 3rd category name': 'Use 3rd category name',
    'Product type': 'Product type',
    'Apply to all': 'Apply to all',
    Collection: 'Collection',
    Status: 'Status',
    'Upload History': 'Upload History',
    'Export Review': 'Export Review',
    Edit: 'Edit',
    All: 'All',
    Uploading: 'Uploading',
    Updating: 'Updating',
    'Start Time': 'Start Time',
    Progress: 'Progress',
    '(Success|Failed|Ignored)': '(Success|Failed|Ignored)',
    'Export reviews that have been successfully uploaded. You can introduce product reviews to Shopify stores.': 'Export reviews that have been successfully uploaded. You can introduce product reviews to Shopify stores.',
    ProductReview: 'ProductReview',
    Products: 'Products',
    'Item#': 'Item#',
    SPU: 'SPU',
    Original: 'Original',
    Markup: 'Markup',
    Total: 'Total',
    Price: 'Price',
    'Listing Status': 'Listing Status',
    Remark: 'Remark',
    'Update Time': 'Update Time',
    Options: 'Options',
    'Price rounding': 'Price rounding',
    to: 'to',
    'then subtract': 'then subtract',
    Others: 'Others',
    'Add category names to tags': 'Add category names to tags',
    'Upload to Shopify collection': 'Upload to Shopify collection',
    'Manage products published from SUNSKY to the store.The next version will support manually adding products': 'Manage products published from SUNSKY to the store.The next version will support manually adding products',
    'Upload Products': 'Upload Products'
  },
  queueList: {
    'Item #': 'Item #',
    Store: 'Store',
    Products: 'Products',
    'SUNSKY Price': 'SUNSKY Price',
    Publish: 'Publish',
    Options: 'Options',
    'include shipping': 'include shipping',
    'Repeated publication': 'Repeated publication',
    'Auto Update': 'Auto Update',
    Queue: 'Queue',
    'On Listing': 'On Listing',
    Listed: 'Listed',
    'Listing Failed': 'Listing Failed',
    Markup: 'Markup',
    'Selling Price': 'Selling Price',
    Reason: 'Reason',
    'Update Time': 'Update Time'
  },
  connection: {
    'Note: The variant SKU of Woocommerce, Shift4shop, and Wix platforms are all the same by default. Please verify the product': 'Note: The variant SKU of Woocommerce, Shift4shop, and Wix platforms are all the same by default. Please verify the product',
    'Through this function, you can replace the products listed in SUNKY ERP. Or select multiple products to form a combination product': 'Through this function, you can replace the products listed in SUNKY ERP. Or select multiple products to form a combination product',
    Price: 'Price',
    'Store Products': 'Store Products',
    'If your store product is a combination set, please select multiple products': 'If your store product is a combination set, please select multiple products',
    Store: 'Store',
    SKU: 'SKU',
    'Platform SKU': 'Platform SKU',
    'SUNSKY SKU': 'SUNSKY SKU',
    'Select Product': 'Select Product',
    Connect: 'Connect',
    'If your product is a combination set, please select multiple products': 'If your product is a combination set, please select multiple products',
    'Shopify Product': 'Shopify Product',
    'SUNSKY Product': 'SUNSKY Product',
    'Store Product': 'Store Product',
    Unit: 'Unit',
    Action: 'Action',
    Status: 'Status',
    'Add Connect': 'Add Connect',
    Variant: 'Variant',
    'If the order product is not listed through SUNSKY, you need to connect before you can place the order': 'If the order product is not listed through SUNSKY, you need to connect before you can place the order',
    'Through [Add Connect], you can replace products listed through SUNSKY': 'Through [Add Connect], you can replace products listed through SUNSKY',
    'Upload Products': 'Upload Products',
    'Please search for SUNSKY ItemNo': 'Please search for SUNSKY ItemNo',
    'Go to sunsky-online.com': 'Go to sunsky-online.com',
    'Please select a store first': 'Please select a store first',
    'Are you sure to cancel the connection': 'Are you sure to cancel the connection',
    'Are you sure to delete the connection': 'Are you sure to delete the connection',
    Pending: 'Pending',
    Connected: 'Connected',
    SubAccountList: 'SubAccountList'
  },
  monitor: {
    monitor_sunsky_user: 'SUNSKY User',
    monitor_contact: 'Contact',
    monitor_Order: 'Order #',
    monitor_country: 'Country',
    monitor_Payment: 'Payment',
    monitor_Fulfillment: 'Fulfillment'
  },
  constval: {
    Update: 'Update',
    Delist: 'Delist',
    Enlist: 'Enlist',
    Deleted: 'Deleted',
    Sync: 'Sync',
    Upload: 'Upload',
    Wait: 'Wait',
    Processing: 'Processing',
    Uploaded: 'Uploaded',
    Finish: 'Finish',
    Fail: 'Fail',
    Ignore: 'Ignore',
    Unpaid: 'Unpaid',
    Paid: 'Paid',
    Shipped: 'Shipped',
    Cancelled: 'Cancelled',
    Delivered: 'Delivered',
    Pending: 'Pending',
    Warning: 'Warning',
    Delete: 'Delete'
  },
  components: {
    components_products_selected: 'products selected'
  }
}
